import { useState, useEffect } from "react";

/**
 * Aktuális UI csomag: "classic" | "studio" (localStorage: xclean_ui).
 * Beállításokban váltáskor `xclean:ui-changed` eseményt kapunk.
 */
export function useUiVariant() {
  const read = () => {
    try {
      return localStorage.getItem("xclean_ui") || "studio";
    } catch {
      return "studio";
    }
  };

  const [ui, setUi] = useState(read);

  useEffect(() => {
    const onChange = () => setUi(read());
    window.addEventListener("xclean:ui-changed", onChange);
    return () => window.removeEventListener("xclean:ui-changed", onChange);
  }, []);

  return ui === "studio" ? "studio" : "classic";
}
